import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import App from "../App";
import StepsPage from "../pages/steps/Steps.page";
import SendFormPage from "../pages/sendForm/SendForm.page";
import HistoryForm from "../pages/historyForm/HistoryForm.page";

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/forms" element={<App />} />
        <Route path="/forms/steps" element={<StepsPage />} />
        <Route path="/forms/sendForm" element={<SendFormPage />} />
        <Route path="/forms/formsHistory" element={<HistoryForm />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
